import fetch from '../../../utils/fetch';
import {
    USER_ANSWER_LIST_RESET,
    USER_ANSWER_LIST_STATS_SUCCESS,
    USER_ANSWER_LIST_SUCCESS,
    USER_ANSWER_LIST_VIEW
} from './mutation-types';
import {HYDRA_MEMBER, HYDRA_TOTAL_ITEMS, HYDRA_VIEW} from '../../../constants/hydra';


const getDefaultState = () => {
    return {
        items: [],
        view: [],
        stats: {isFantasyAvg: 0, isActionAvg: 0, isSkippedAvg: 0, gaugeLevelAvg: 0, total: 0, bookmarkAvg: 0},
        totalItems: 0
    };
};
const state = getDefaultState();

function success(items, totalItems) {
    return {type: USER_ANSWER_LIST_SUCCESS, items, totalItems};
}

function statsSuccess(stats) {
    return {type: USER_ANSWER_LIST_STATS_SUCCESS, stats};
}

function view(items) {
    return {type: USER_ANSWER_LIST_VIEW, items};
}

function reset() {
    return {type: USER_ANSWER_LIST_RESET};
}

const getters = {
    error: state => state.error,
    items: state => state.items,
    totalItems: state => state.totalItems,
    loading: state => state.loading,
    view: state => state.view,
    stats: state => state.stats
};

const actions = {
    getItems({commit}, url) {
        if (typeof url === 'string') {
            url = {listUrl: url};
        }
        fetch(url.listUrl)
            .then(data => {
                commit(success(data[HYDRA_MEMBER], data[HYDRA_TOTAL_ITEMS]));
                commit(view(data[HYDRA_VIEW]));
            });
        if (url.statsUrl) {
            fetch(url.statsUrl)
                .then(data => {
                    commit(statsSuccess(data));
                });
        }
    },
    reset({commit}) {
        commit(reset());
    }
};

const mutations = {
    [USER_ANSWER_LIST_VIEW](state, payload) {
        state.view = payload.items;
    },
    [USER_ANSWER_LIST_SUCCESS](state, payload) {
        state.items = payload.items;
        state.totalItems = payload.totalItems;
    },
    [USER_ANSWER_LIST_STATS_SUCCESS](state, {stats}) {
        state.stats = stats;
    },
    [USER_ANSWER_LIST_RESET](state) {
        Object.assign(state, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/userAnswer/list.js